var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 186.02 186.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #ae2d24;\n      }\n\n      .cls-4 {\n        fill: #1a1a97;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 93.01,
    cy: 93.01,
    r: 93.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 0.11,
    width: 186.02,
    height: 31.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 154.86,
    width: 186.02,
    height: 31.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 31.16,
    width: 186.02,
    height: 31.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 123.64,
    width: 186.02,
    height: 31.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 61.18,
    width: 186.02,
    height: 31.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 92.41,
    width: 186.02,
    height: 31.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThai);
export default __webpack_public_path__ + "static/media/thai.4dccfd139a3168956b015b9a5c540c4c.svg";
export { ForwardRef as ReactComponent };